module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAABH0lEQVQ4T5XRwSrEURgF8HPuFdnY2VhJLNx7Z4VslIUHIBZWpmbjAayUDWVjYWujZmVD8QDiDWz8u3eakqSU8gQjY45uUZT+M/+7/Dq/ztf9iJKXUutc0rwxXHLOvf6OsgzGmB4BTJFm3/vZg4Fgu92e6HY/XwCQ5IX3bnMgmFI6lrCTwyTPvHdbfWFRFMvWDt1KsjlsDI+cc7ulMKW0KOEawNhPUOpt1Gq1qz8wxtQBMJKHOWCMqUtYLfs0kk+MMb0DGM7BXk8Na7nWDwLoMMbWG6DxKpBEzI0PAKarQTZz4x2guSoQ0DZTSjcSVqpAEjO58RLQegX4HIKfzI1NCY3BIU9DcHnV1qGkve871iVaa82JpNF/bvkBaCGEcP8Fzkib1WY3MzoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/praise_no.png
// module id = k23o
// module chunks = 0